export default __webpack_public_path__ + "static/media/upright-arrow.5890cbb6.svg";